export const EQUITY_CATEGORY_LIST = [
  {
    name: '经营权益',
    code: 1,
  },
  {
    name: '发展权益',
    code: 2,
  },
  {
    name: '存量权益',
    code: 3,
  },
  {
    name: '活动权益',
    code: 4,
  },
]
